import React from 'react';

const EstonianPage = () => {
    return (
        <div>
            <p>
                <b>
                    <span lang="FI">
                        Infokiri enesehindamise uurimisest teaduseetika õppimise kontekstis
                    </span>
                </b>
            </p>

            <p>
                <span lang="FI">
                    Meie, Refleksioonikompassi rakenduse arendajad, oleme Helsingi Ülikooli
                    Haridusteaduskonna õpetamise ja õppimise uurijad. Soovime mõista enesehindamist
                    ja selle täpsust teaduseetika õppimise kontekstis ning analüüsida, kuidas
                    ühtivad tudengite enesehinnang ja nende kirjalikud vastused. Samuti oleme
                    huvitatud vastavustest ja mittevastavustest tudengite enesehinnangust oma
                    arusaamise tasemele ja õpetaja võimaliku hinnangu vahel. Me ei analüüsi õpetaja
                    poolt antud õppeülesandeid.
                </span>
            </p>

            <p>
                <span lang="FI">
                    Uuringus osalemine on vabatahtlik. Esiteks palume õpetajal lubada meil kasutada
                    selle rakenduse kaudu loodud sisu. Kui õpetaja annab nõusoleku, saadab süsteem
                    kursuse tudengitele taotluse. Kui õpetaja keeldub rakenduse kaudu genereeritud
                    teabe kasutamisest, ei saada süsteem tudengitele taotlust. Tudengite teavet, kes
                    ei ole nõusolekut andnud, ei kasutata, isegi kui õpetaja on nõusoleku andnud.
                    Uuringus osalemine aitab meil arendada teaduseetika õpetamist.
                </span>
            </p>

            <p>
                <span lang="FI">
                    Viited konkreetsetele isikutele, kohtadele või asutustele anonümiseeritakse.
                    Teadlased töötavad ainult anonümiseeritud andmetega. Uuring järgib Soome
                    Riikliku Teaduseetika Nõukogu juhiseid. Me ei avalda isiklikku teavet ja tagame
                    teie anonüümsuse uurimisaruannetes ja teadusartiklites. Kõiki andmeid
                    hoiustatakse Helsingi Ülikooli parooliga kaitstud kontodel. Kui soovite
                    uuringust loobuda, võite seda teha igal hetkel ilma põhjust esitamata ja ilma
                    tagajärgedeta. Võite loobuda, võttes ühendust alloleval e-posti aadressil. Kuna
                    teadlased töötavad anonümiseeritud andmetega, ei pruugi olla võimalik teie
                    andmeid pärast teatud etappe uurimisprotsessis jälitada.
                </span>
            </p>

            <p>
                <span lang="FI">
                    Kui teil on küsimusi, ärge kõhelge ühendust võtmast: Erika Löfström
                    erika.lofstrom@helsinki.fi
                </span>
            </p>

            <p>
                <b>
                    <span lang="FI">Nõusolek</span>
                </b>
            </p>

            <p>Ma mõistan, et …</p>

            <p>
                <span lang="FI" className="p">
                    osalemine uuringus on vabatahtlik ja ma võin oma osalemise igal hetkel lõpetada
                    ilma põhjust esitamata
                </span>
            </p>

            <p>
                <span lang="FI" className="p">
                    mul on õigus oma nõusolek tagasi võtta ja paluda teadlastel juba kogutud andmed
                    eemaldada. Ma mõistan, et sel hetkel võivad teadlastel olla ainult
                    anonümiseeritud andmed.
                </span>
            </p>

            <p>
                <span lang="FI" className="p">
                    minu identiteeti või teavet, mis võiks viia minu identiteedi avalikustamiseni,
                    teadlased ei avalda
                </span>
            </p>

            <p>
                <span lang="FI" className="p">
                    võin teadlastega ühendust võtta, kui mul on uuringu kohta küsimusi
                </span>
            </p>
        </div>
    );
};

export default EstonianPage;
